<template>
    <div class="a-input input">
        <label :for="id">
            <span class="input-label">{{placeholder}}</span>
            <Input
                :element-id="id"
                :value="localValue"
                :disabled="disabled"
                :maxlength="maxLength"
                :placeholder="placeholder"
                :clearable="clearable"
                :prefix="prefix"
                :type="inputType"
                @on-focus="handleFocus"
                @on-blur="handleBlur"
                @on-change="handleInput($event.target.value)"
                @on-clear="handleClear"
            />
        </label>
    </div>
</template>

<script>
export default {
    name: 'AInput',
    props: {
        value: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        maxLength: {
            type: Number,
            default: 50
        },
        placeholder: {
            type: String,
            default: ''
        },
        clearable: {
            type: Boolean,
            default: false
        },
        prefix: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: null
        },
        id: {
            type: String,
            default: 'a-input-42'
        },
        inputType: {
            type: String,
            default: 'text'
        }
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(e) {
                this.$emit('input', e)
            }
        }
    },
    methods: {
        handleClear() {
            this.$emit('onClear');
        },
        handleInput(evt) {
            this.localValue = evt;
            this.$emit('onChange', evt);
        },
        handleFocus() {
            this.$emit('onFocus', true);
        },
        handleBlur() {
            this.$emit('onBlur', true);
        }
    }
}
</script>

<style lang="scss">
@import "a-input";
</style>
